module.exports = __webpack_public_path__ + "static/media/Roboto-SemiBold.dae3c6ed.ttf";